module.exports = __webpack_public_path__ + "static/media/icon-dash-sharing.902356a5.png";